import { schema } from "normalizr";

export const postPreviewSchema = new schema.Entity("postPreviews");
export const postSchema = new schema.Entity("posts");